import React from "react";
import { useNavigate } from "react-router-dom";
import "./OnlineTraining.css";

import onlineImg1 from "../assets/OnlineTraining.png";

import {
  FaLaptop,
  FaWifi,
  FaUserGraduate,
  FaProjectDiagram,
  FaArrowRight,
} from "react-icons/fa";

const OnlineTraining = () => {
  const navigate = useNavigate();

  return (
    <div className="online-page">
      <div className="online-hero">
        <div className="breadcrumb">
          <span className="breadcrumb-link" onClick={() => navigate("/")}>
            Home
          </span>

          <span className="separator"> / </span>

          <span className="active-page">Online Training</span>
        </div>
      </div>

      <div className="section">
        <div className="container-flex">
          <div className="left">
            <img src={onlineImg1} alt="online training" />
          </div>

          <div className="right">
            <h2>About Online Training</h2>

            <p>
              Our Online Training programs are designed for flexibility and
              accessibility, allowing learners to gain industry-level skills
              from anywhere.
            </p>

            <p>
              With live sessions, recorded classes, and expert mentorship,
              students can learn at their own pace while building strong
              technical foundations.
            </p>

            <div className="points">
              <p>
                <FaArrowRight /> Learn from anywhere
              </p>
              <p>
                <FaArrowRight /> Live + recorded sessions
              </p>
              <p>
                <FaArrowRight /> Real-time doubt support
              </p>
              <p>
                <FaArrowRight /> Job-oriented curriculum
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <h2>Why Choose Our Online Training?</h2>

        <div className="features-grid">
          <div className="feature-card">
            <FaLaptop className="icon" />
            <h3>Flexible Learning</h3>
            <p>Access training anytime, anywhere.</p>
          </div>

          <div className="feature-card">
            <FaWifi className="icon" />
            <h3>Live Sessions</h3>
            <p>Interactive real-time classes with trainers.</p>
          </div>

          <div className="feature-card">
            <FaUserGraduate className="icon" />
            <h3>Expert Mentorship</h3>
            <p>Guidance from experienced professionals.</p>
          </div>

          <div className="feature-card">
            <FaProjectDiagram className="icon" />
            <h3>Real Projects</h3>
            <p>Work on industry-level applications.</p>
          </div>
        </div>
      </div>

      <div className="section center-section">
        <div className="center-content">
          <h2>What You Will Gain</h2>

          <ul>
            <li>✔ Strong technical foundation</li>
            <li>✔ Hands-on project experience</li>
            <li>✔ Confidence in interviews</li>
            <li>✔ Industry-ready skills</li>
          </ul>

          <p>
            Our focus is to transform learners into confident professionals
            ready to handle real-world challenges.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OnlineTraining;
